import { memo } from "react";

function InternationalMarkets() {
  return (
    <main className="container mt-5" aria-label="International Markets">
      <div className="row">
        <h1>International Markets</h1>
      </div>
    </main>
  );
}

InternationalMarkets.displayName = "InternationalMarkets";

export default memo(InternationalMarkets);